import { render } from "./GiftNftModal.vue?vue&type=template&id=1ffdaf61&scoped=true"
import script from "./GiftNftModal.vue?vue&type=script&lang=js"
export * from "./GiftNftModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/giftNftModal.scss?vue&type=style&index=0&id=1ffdaf61&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffdaf61"]])

export default __exports__